import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ComputerBasedTest from "../ComputerBasedTest/ComputerBasedTest";
import QuestionsPage from "../ComputerBasedTest/QuestionsPage";

const CommonRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<Navigate to={"/"} />} />
      <Route path="/" element={<ComputerBasedTest />} />
      <Route extact path="/computerbasedtest" element={<ComputerBasedTest />} />
      <Route extact path="/questionspage" element={<QuestionsPage />} />
    </Routes>
  );
};

export default CommonRoutes;